<template>
  <van-nav-bar
    :title="title"
    :fixed="fixed"
    left-arrow
    class="header"
    @click-left="onLeftClick"
  />
</template>

<script>
import { NavBar } from "vant";

export default {
  name: "HeadNavBar",
  components: {
    [NavBar.name]: NavBar,
  },
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onLeftClick() {
      if (this.$listeners["click-left"]) {
        this.$emit("click-left");
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  border-bottom: 1px solid #fafafa;
}
</style>
